<template>
  <div id="app">
    <box v-if="isLoadToken"/>
  </div>
</template>

<script>
import {getToken} from '@/api/lsyn2.js'
import box from '@/views/box.vue'

export default {
  components: {box},
  data() {
    return {
      isLoadToken: false
    }
  },
  created() {
    getToken().then(res => {
      console.log(res, "获取token")
      localStorage.setItem('screenToken', res.data.token)
      localStorage.setItem('userId', res.data.userid)
      this.isLoadToken = true
    })
  }
}
</script>

<style lang="less">
#app {
  width: 100vw;
  height: 100vh;
  background-color: #010E0D;
}

</style>
